module.exports = true;



//////////////////
// WEBPACK FOOTER
// C:/Users/pc 01/AppData/Roaming/npm/node_modules/@vue/cli-service-global/node_modules/core-js/library/modules/_library.js
// module id = 3twX
// module chunks = 0